import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ProdutoModalidade } from '../../../models/produto-modalidade.model';
import { ProdutoModalidadeService } from '../../../services/produto-modalidade.service';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProdutoEtapaModalidade } from '../../../models/produto-etapa-modalidade.model';
import { AtualizacoesAudit } from '../../../models/atualizacoes-audit.model';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';

@Component({
  selector: 'app-produto-modalidade-edit',
  templateUrl: './produto-modalidade-edit.component.html',
  styleUrls: ['./produto-modalidade-edit.component.scss'],
})
export class ProdutoModalidadeEditComponent
  extends BaseFormComponent<ProdutoModalidade>
  implements OnInit
{
  actionLabel: string = 'Novo';
  etapasList: ProdutoEtapaModalidade[];
  statusList: [];
  audit: AtualizacoesAudit;

  constructor(
    private myService: ProdutoModalidadeService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.loaded();
    this.etapasList = this.activatedRoute.snapshot.data.etapasList;
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      etapas: new FormArray([]),
      name: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
      ]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
      this.statusList = this.entity.statusList;

      this.etapasList?.forEach((etapaList) => {
        this.itensFormArray().push(this.criarItemFormGroup(etapaList));
      });

      this.audit = {
        prod_template_id: this.entity.id,
      };
    }
  }

  criarItemFormGroup(etapaList = null): FormGroup {
    let etapa = this.getEtapaSelecionada(etapaList?.id);
    const isSelected = etapa ? true : false;
    const comtemplated = etapa?.comtemplated ? etapa.comtemplated : '0';

    return new FormGroup({
      id: new FormControl(etapa?.id),
      etapa_modalidade_id: new FormControl(etapaList?.id),
      name: new FormControl(etapaList?.name),
      selecionado: new FormControl(isSelected),
      comtemplated: new FormControl({
        value: comtemplated,
        disabled: !isSelected,
      }),
    });
  }

  getEtapaSelecionada(id) {
    const etapa = this.entity?.etapas?.find(
      (etapa) => etapa.produto_etapa_modalidade_id == id
    );
    return etapa;
  }

  getNameValue(etapaForm): string {
    return etapaForm.get('name').value;
  }

  onCheckboxChange(event, etapaForm) {
    const checked = event.target.checked;
    if (checked) {
      etapaForm.get('comtemplated').enable();
    } else {
      etapaForm.get('comtemplated').disable();
    }
  }

  itensFormArray(): FormArray {
    return this.form.get('etapas') as FormArray;
  }

  voltar() {
    this.navigation.back(['pre-projeto/admin/produto-modalidade']);
  }

  getDataCreate(): ProdutoModalidade {
    let data: ProdutoModalidade;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService
            .update(this.getDataCreate(), this.entity?.id)
            .subscribe({
              next: (res: ProdutoModalidade) => {
                this.msgSuccess('Cadastro alterado com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error.message);
                this.loaded();
              },
            })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: ProdutoModalidade) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace([
                'pre-projeto/admin/produto-modalidade/',
                res.id,
              ]);
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error.message);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }
}
